import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const fetchBalance = (query) => http.get(`${api}/gerencia/balance`, { params: { ...query } })

export {
  fetchBalance
}
